<template>
  <div class="edis-osago">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Серия</label>
        <!--input type="text" class="form-control" v-model="data.series" placeholder required /-->
        <imask-input type="text"
          class="form-control"
          :mask="'[aaa]'"
          v-model="data.series"
          :prepare="str => str.toUpperCase()"
          placeholder="AAA"
          required
        />
      </div>
      <div class="col-md-4 mb-2">
        <label>Номер</label>
        <imask-input type="text"
          class="form-control"
          :mask="'[0000000000]'"
          v-model="data.number"
          placeholder="01234567890"
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
const type = 'osago'

export default {
  name: 'DocumentOsagoEdit',
  props: ['documentData'],
  data () {
    return {
      data: {
        series: '',
        number: ''
      }
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
    this.update()
  },
  methods: {
    update () {
      this.$emit('update', {
        type: type,
        data: this.data
      })
    }
  },
  watch: {
    data: {
      handler () {
        this.update()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .edis-osago input {
    margin-bottom: 5px;
  }
  .edis-osago textarea {
    margin-bottom: 5px;
  }
</style>
